// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"25":"93b2a076019b79700703","155":"acfeeaab51c1d43d5cd5"}[chunkId] + ".js";
};